import { Directive, ElementRef, NgZone } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { PopoverBaseDirective } from 'Angular/features/directives/popovers/base/popover-base.directive';

/**
 * Tooltip Directive
 *
 * Extends the base popover directive and sets the event listeners to be on mouseenter for showing and on mouseleave
 * for hiding
 *
 */
@Directive({
    standalone: false,
    selector: '[ycnTooltip]',
})
export class TooltipDirective extends PopoverBaseDirective {
    constructor(protected el: ElementRef, sanitizer: DomSanitizer, private ngZone: NgZone) {
        super(el, sanitizer);
        this.ngZone.runOutsideAngular(() => {
            this.el.nativeElement.addEventListener('mouseenter', () => {
                this.showTooltip();
            });
            this.el.nativeElement.addEventListener('mouseleave', () => {
                this.hideTooltip();
            });
        });
    }
}
